import { HttpContext, HttpContextToken } from '@angular/common/http';

/**
 * Banderas que un request puede llevar para cambiar el comportamiento de los
 * interceptores. Se usan con `new HttpContext().set(TOKEN, valor)`.
 */

/** No agrega `Authorization` ni `x-permiso`, y no intenta refrescar ante un 401. */
export const SIN_AUTENTICACION = new HttpContextToken<boolean>(() => false);

/** La URL ya es absoluta: el interceptor de base no la toca. */
export const URL_ABSOLUTA = new HttpContextToken<boolean>(() => false);

/** El error no se notifica solo: lo maneja quien llama. */
export const SIN_NOTIFICAR_ERROR = new HttpContextToken<boolean>(() => false);

/**
 * No mueve la barra de progreso del encabezado. Para los sondeos en segundo
 * plano: una barra que parpadea cada cinco segundos durante minutos se lee como
 * que la pantalla está cargando algo.
 */
export const SIN_CARGA = new HttpContextToken<boolean>(() => false);

/** Manda el request a `gestion-cron` en vez de a `gestion-api-gestion`. */
export const API_CRON = new HttpContextToken<boolean>(() => false);

/** Azúcar para no repetir `new HttpContext().set(...)` en cada llamada. */
export function contexto(...banderas: HttpContextToken<boolean>[]): HttpContext {
  return banderas.reduce((ctx, bandera) => ctx.set(bandera, true), new HttpContext());
}
